import { blogHref, careersHref } from "../../utils/navigation"

export const menuOptions = [
  {
    title: "Menu_header_solutions",
    elements: [
      {
        title: "Menu_header_automotive",
        url: "solutions/automotive",
      },
      {
        title: "Menu_header_buying",
        url: "solutions/buying",
      },
      {
        title: "Menu_header_selling",
        url: "solutions/selling",
      },
      {
        title: "Menu_header_financing",
        url: "solutions/financing",
      },
      {
        title: "Menu_header_logistics",
        url: "solutions/logistics",
      },
    ],
  },
  {
    title: "Navbar_Metals",
    elements: [
      {
        title: "Navbar_Copper",
        url: "metals/copper",
      },
      {
        title: "Navbar_Aluminum",
        url: "metals/aluminum",
      },
      {
        title: "Navbar_StainlessSteel",
        url: "metals/stainless-steel",
      },
      {
        title: "Navbar_FerrousMetals",
        url: "metals/ferrous",
      },
    ],
  },
  {
    title: "Navbar_Resources",
    elements: [
      {
        title: "Scrap_Prices",
        url: "scrap-metal-price",
      },
      {
        title: "Menu-bar_Datahub",
        url: "datahub",
      },
      {
        title: "Blog",
        url: blogHref,
      },
    ],
  },

  {
    title: "Menu-bar_About_Us",
    elements: [
      {
        title: "Menu-bar_About-metaloop",
        url: "about-us",
      },
      {
        title: "Menu_header_team",
        url: "about-us/team",
      },
      {
        title: "Menu-bar_Impact",
        url: "about-us/impact",
      },
      {
        title: "Menu_header_faq",
        url: "about-us/faq",
      },
      {
        title: "Menu_header_casestudies",
        url: "case-studies",
      },
    ],
  },
  {
    title: "Navbar_Contact",
    url: "contact-us",
  },
  /*{
    title: "Button_Careers",
    url: careersHref,
  },*/
]
